import type { SVGProps } from 'react';
const SvgSignalCellular0Bar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#signal_cellular_0_bar_svg__a)">
      <path fill="currentColor" d="M20 6.83V20H6.83L20 6.83ZM22 2 2 22h20V2Z" />
    </g>
    <defs>
      <clipPath id="signal_cellular_0_bar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSignalCellular0Bar;
